import { FieldAlert } from '@dixa/lib-shared-habla';

import {
  userModalActions,
  UserModalFieldAlertProps,
} from 'components/usersModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export const UserModalFieldAlert = ({
  field,
  userId,
}: UserModalFieldAlertProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const alert = `${field} is already used by another user`;

  if (!userId) {
    return <>{alert}</>;
  }

  return (
    <span>
      {alert}
      <FieldAlert.Button
        onClick={() => dispatch(userModalActions.user.get({ userId }))}
      >
        Load the user
      </FieldAlert.Button>
    </span>
  );
};
